import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VFooter,{attrs:{"app":"","color":"primary","padless":""}},[_c(VCol,{staticClass:"pa-0 text-right white--text",attrs:{"cols":"6"}},[_vm._v(" "+_vm._s(_vm.fullName)+" ")]),_c(VCol,{staticClass:"pa-0 text-right white--text pr-3",attrs:{"cols":"6"}},[_vm._v(" "+_vm._s(_vm.date + " " + _vm.time)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }